import { render, staticRenderFns } from "./SettingLogout.vue?vue&type=template&id=77a797ed&"
import script from "./SettingLogout.vue?vue&type=script&lang=js&"
export * from "./SettingLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports